import React, {FC, useEffect, useState} from 'react';
import {Button, Dimmer, Icon, Loader, Modal, ModalProps} from 'semantic-ui-react';
import Pagination from './Pagination';
import * as XLSX from 'xlsx';
import {Table} from 'semantic-ui-react';
import {envColor} from "../common";

interface Props extends ModalProps {
    file?: { name: string, url: string, chunk: string, chunkCounts: number, index: number };
    onClose: () => void;
    filePageChange: (url: string, index: number) => void;
    loading: boolean;
    saveFile: (url: string) => void;
}


const FileChunkWindow: FC<Props> = (props) => {
    const [excelData, setExcelData] = useState<string[][]>([]);
    useEffect(() => {
        processChunk(chunk);
    }, []);

    if (props.file === undefined) {
        return <div></div>;
    }

    const {file, onClose, filePageChange, loading, saveFile, ...modalProps} = props;
    const {name, url, chunk, chunkCounts, index} = file;
    const isExcelData = ['xls', 'xlsx'].some(ending => name.endsWith(ending));

    const processChunk = (chunk: string) => {
        if (isExcelData) {
            const workbook = XLSX.read(chunk, {type: 'binary'});
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const data = XLSX.utils.sheet_to_json(worksheet, {header: 1}) as string[][];
            setExcelData(data);
        }
    };

    return (
        <Modal
            size='large'
            style={{minWidth: '70%', maxWidth: '95%'}}
            closeIcon
            open={true}
            {...modalProps}
            onClose={onClose}
        >
            <Modal.Header>{name}</Modal.Header>
            <Modal.Content scrolling>
                {loading ?
                    <Dimmer inverted active={true}><Loader/></Dimmer> :
                    <>
                        <Modal.Description>
                            {isExcelData ? (
                                <Table celled>
                                    <Table.Header>
                                        <Table.Row>
                                            {
                                                excelData.length > 0 &&
                                                excelData[0].map((cell, index) => (
                                                    <Table.HeaderCell key={index}>{cell}</Table.HeaderCell>
                                                ))
                                            }
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {excelData.length > 1 &&
                                            excelData.slice(1).map((row, index) => (
                                                <Table.Row key={index}>
                                                    {row.map((cell, index) => (
                                                        <Table.Cell key={index}>{cell}</Table.Cell>
                                                    ))}
                                                </Table.Row>
                                            ))}
                                    </Table.Body>
                                </Table>
                            ) : (
                                <pre style={{overflow: 'overlay'}}>{chunk}</pre>
                            )}
                        </Modal.Description>
                    </>
                }
            </Modal.Content>
            <Modal.Actions>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '2fr 50% 1fr 1fr',
                    gridGap: '12px',
                    alignItems: 'center',
                }}>
                    <div></div>
                    {chunkCounts > 1 ? (
                        <Pagination
                            activePage={index}
                            onPageChange={(newPage) =>
                                filePageChange(url, newPage)
                            }
                            totalPages={chunkCounts}
                        />
                    ) : (
                        <div></div>
                    )}
                    <Button circular icon labelPosition='left' color={envColor} onClick={() => saveFile(url)}>
                        <Icon name='save'/>
                        Save
                    </Button>
                    <Button circular onClick={onClose}>
                        Close
                    </Button>
                </div>
            </Modal.Actions>
        </Modal>
    )
}

export default FileChunkWindow;